import React from 'react'
import { useState } from 'react';

const ShowMessage = (props) => {
    const [closePopUp, setClosePopUp] = useState(true)
    let modalData = props.statedata;

    const onClickPopClose = () => {
        setClosePopUp(x => !x)
        props.onClosePopup(false)
    }

    return (
        <div className='show-msg-pop-up'>
            {
                closePopUp ?
                    <div className={`pop-up ${modalData && 'active'}`}>
                        <div className='popup-wrapper'>
                            <div className='popup-content'>
                                <button className="close-popup">

                                    <i className="cancel-icon" onClick={(e) => {

                                        onClickPopClose()
                                    }}></i>
                                </button>
                                <p> Please install metamask extension<br /> <br />
                                    <a href={"https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en"}
                                        style={{ color: '#faff02', paddingLeft: '50px' }}>  Click Here to Download</a>
                                </p>
                            </div>
                        </div>
                    </div>
                    : null

            }
        </div>

    )
}

export default ShowMessage